import React from "react";

import MaturaFunctionGraph from "../../../../components/GraphPlotter/MaturaFunctionGraph";

const DEFAULT_RANGE = [-6, 6];
const GUIDE_COLOR = "#8b5cf6";

export function buildInequalityHighlightBands({
  intervals,
  threshold,
  operator,
  yRange = DEFAULT_RANGE,
}) {
  const normalizedIntervals = Array.isArray(intervals)
    ? intervals
    : intervals
    ? [intervals]
    : [];
  const shadesAbove = operator === ">" || operator === ">=";

  return normalizedIntervals.map((interval) => ({
    left: interval.left,
    right: interval.right,
    yref: "y",
    y0: shadesAbove ? threshold : yRange[0],
    y1: shadesAbove ? yRange[1] : threshold,
    color: GUIDE_COLOR,
    opacity: 0.14,
  }));
}

export default function MaturaPiecewiseInequalityExplanationGraph({
  points,
  segments = [],
  curves = [],
  solutionIntervals,
  threshold,
  operator,
  xRange = DEFAULT_RANGE,
  yRange = DEFAULT_RANGE,
}) {
  return (
    <MaturaFunctionGraph
      points={points}
      segments={segments}
      curves={curves}
      equations={[{
        expr: `y=${threshold}`,
        color: GUIDE_COLOR,
        width: 2,
        dash: "dot",
      }]}
      verticalBands={buildInequalityHighlightBands({
        intervals: solutionIntervals,
        threshold,
        operator,
        yRange,
      })}
      xRange={xRange}
      yRange={yRange}
    />
  );
}
